/*!
 * scroll-to-top.js v1.0.0
 *
 * Copyright Rolf Engelhard, www.rolf-engelhard.de
 */
$(document).ready(function() {
	'use strict';

	function scroller(elem) {
		if ($(elem).scrollTop() <= 180) {
			$('.scroll-to-top a').css('opacity', '0.0');
		} else {
			$('.scroll-to-top a').css('opacity', '0.8');
		}
	}

	scroller($(window));

	$(window).scroll(function() {
        scroller(this);
    });

	$('.scroll-to-top a').click(function() {
        $('html, body').animate({ scrollTop: 0 }, 500);
        return false;
    });

});
